var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules"},[_c('h3',[_vm._v(_vm._s(_vm.$t('getCardSuccess.rules_title')))]),_vm._v(" "),_c('ul',_vm._l((_vm.$t('getCardSuccess.rules')),function(it){return _c('li',{domProps:{"innerHTML":_vm._s(it)}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6a07bc55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/rules.vue
// module id = null
// module chunks = 